import { render, staticRenderFns } from "./AddEditInsurancePolicy.vue?vue&type=template&id=8e360c86&scoped=true"
import script from "./AddEditInsurancePolicy.vue?vue&type=script&lang=js"
export * from "./AddEditInsurancePolicy.vue?vue&type=script&lang=js"
import style0 from "./AddEditInsurancePolicy.vue?vue&type=style&index=0&id=8e360c86&prod&scoped=true&lang=css"
import style1 from "./AddEditInsurancePolicy.vue?vue&type=style&index=1&id=8e360c86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e360c86",
  null
  
)

export default component.exports